import {
	createApp
} from 'vue';
import App from './App.vue';
import router from './router';
import {
	createI18n
} from 'vue-i18n';
import axios from 'axios';
import './styles/main.scss';
import {
	initKeycloak
} from './keycloak';
import VueSplide from '@splidejs/vue-splide';
import CounterAni from './components/Counter.vue';
import MobileNav from '@/components/MobileNav.vue';
import './registerServiceWorker';
import VueGoogleMaps from 'vue-google-maps-community-fork';
import CameraComponent from "@/components/CameraComponent.vue";
import 'animate.css';
import VueGtag from 'vue-gtag'

const i18n = createI18n({
	locale: 'en',
	fallbackLocale: 'en',
	messages: {}
});

async function loadInitialLocale() {
	const savedLocale = localStorage.getItem('lang') || 'en';
	try {
		const currentDate = new Date();
		const formattedDate = currentDate.toISOString().slice(0, 10).replace(/-/g, '');
		const response = await axios.get(`${process.env.VUE_APP_TRANSLATEAPI}${savedLocale}?v=${formattedDate}`);
		const messages = response.data;

		i18n.global.setLocaleMessage(savedLocale, messages);
		i18n.global.locale = savedLocale;
		//localStorage.setItem('lang', savedLocale);
	} catch (error) {
		console.error('Error loading locale messages:', error);
	}
}

const app = createApp(App);
initKeycloak()
	.then(async () => {
		await loadInitialLocale();
		app.use(router);
		app.component('CounterAni', CounterAni);
		app.component('MobileNav', MobileNav);
		app.component('CameraComponent', CameraComponent);

		app.use(VueSplide);
		app.use(i18n);
		app.use(VueGoogleMaps, {
			load: {
				key: 'AIzaSyBA1QtDZwNgmHrupRPowr9VusIp1r_pRqc',
			}
		});
		app.use(VueGtag, {
			config: { 
				id: 'G-HRR5ESV03G',
				params: {
					anonymize_ip: true
				}
			}
		}, router);

		app.mixin({
			methods: {
				goBack() {
					if(typeof this.state?.show !== "undefined" && this.state.show == true){
						this.closePopup();
					} else {
						if (window.history.length > 1) {
							this.$router.back();
						} else {
							this.$router.push('/profile');
						}
					}
				}
			}
		});

		app.mount('#app');
	})
	.catch((error) => {
		console.error('Failed to initialize Keycloak:', error);
	});